export const UPDATESURL = process.env.REACT_APP_UPDATES_API;
export const APPID = process.env.REACT_APP_APP_ID;
export const TRADINGAPP = process.env.REACT_APP_TRADING_APP;
export const DOMIAN = process.env.REACT_APP_DOMIAN;
export const TOKENNAME = process.env.REACT_APP_TOKEN_TYPE;
export const REDIRECTURL = process.env.REACT_APP_REDIRECT_URL;
export const LOCATIONCHECK = process.env.REACT_APP_LOCATION_CHECK;
export const ENV = "prod";
export const UPLOADSIZELIMIT: number =
  process.env.REACT_APP_UPLOAD_SIZE_LIMIT !== undefined
    ? parseInt(process.env.REACT_APP_UPLOAD_SIZE_LIMIT)
    : 8;
export const UploadSizes = {
  signature: {
    pdfSize: 2,
    imageSize: 2,
  },
  pancard: {
    pdfSize: 2,
    imageSize: 2,
  },
  incomeproof: {
    pdfSize: 7,
    imageSize: 3,
  },
  bank_proof: {
    pdfSize: 3,
    imageSize: 3,
  },
  nominee: {
    pdfSize: 5,
    imageSize: 3,
  },
};
